import { Popover, Tag, Tooltip } from "antd"
import { TagProps } from "antd/lib"
import React, { CSSProperties } from "react"
import { ORANGE_SHIVVERS } from "src/app/theme"
import AutomationType from "src/consts/AutomationType"
import BinDTO from "src/models/BinDTO"

const generateHardwareDescriptionItems = (binDTO: BinDTO | null | undefined): string[] => {
    if (binDTO == null) {
        return []
    }
    const bin = binDTO;
    const items: string[] = [];
        // Fans
    const fanCount = bin.fans?.length ?? 0;
    if (fanCount > 0) {
        items.push(`Fans: ${fanCount}`);
    }

    // Moisture cables (BinSense, OPI, RF, moistureCables)
    const binSenseCount = bin.binSenseMoistureCables?.length ?? 0;
    const opiCount = bin.opiMoistureCables?.length ?? 0;
    const rfCount = bin.moistureCables_RF?.length ?? 0;
    const moistureCablesCount = bin.moistureCables?.length ?? 0;
    const totalMoistureCables = binSenseCount + opiCount + rfCount + moistureCablesCount;
    if (totalMoistureCables > 0) {
        items.push(`Moisture cables: ${totalMoistureCables}`);
    }

    // Temperature cables
    const tempCableCount = bin.temperatureCables?.length ?? 0;
    if  (tempCableCount > 0) {
        items.push(`Temperature cables: ${tempCableCount}`);
    }

    // Number of fans (again, if you want this separately)

    // Number of GAMS (if innerSonar or outerSonar is not null)
    let gamsCount = 0;
    if (bin.innerSonar) gamsCount++;
    if (bin.outerSonar) gamsCount++;
    if (gamsCount > 0) {
        items.push(`Range Finders: ${gamsCount}`);
    }

    if (bin.automationType === AutomationType.DriStack) {
        items.push(`Stacks: ${bin?.stacks?.length ?? 0}`);
    }

    if (bin.automationType === AutomationType.DriStack) {
        items.push(`Heater: ${bin.hasHeaters ? "Yes" : "No"}`);
    }

    if (bin?.hasCamera) {
        items.push(`Camera: Yes`);
    }

    return items;
}

export const BinProductTag = (props: {automationType: AutomationType | null | undefined | string,
    tagStyles?: CSSProperties,
    tagColor?: TagProps['color'],
}) => {
        const getTagName = () => {
        if (props.automationType === AutomationType.DriStack) {
            return "DRI-Stack";
        } else if (props.automationType === AutomationType.AutoBin) {
            return "Auto-Bin";
        }
        else if (typeof props.automationType === 'string') {
            return props.automationType;
        }
        else {
            return "";
        }
    }
        return <Tag {...props} style={{
            ...props.tagStyles,
        }} color={props.tagColor ?? ORANGE_SHIVVERS}>{getTagName()}</Tag>
}

export const BinProductDescriptionTag = (props: {binDTO: BinDTO | null | undefined,
    tagStyles?: CSSProperties,
}) => {
    const hardwareOnBoard = generateHardwareDescriptionItems(props.binDTO);
    const formatted = hardwareOnBoard?.map(item => {
        return <div key={item}>{item}</div>;
    })

    return <Popover popupVisible={hardwareOnBoard?.length > 0} title="Hardware Summary" content={formatted} overlayStyle={{maxWidth: '300px'}}>
        <BinProductTag automationType={props.binDTO?.automationType}
                        tagStyles={{
                            fontSize: 10,
                        }}
        />
    </Popover>
}